import styled from '@src/styled-components'



export const BodyContainer = styled.div`
    box-sizing: border-box;
    font-family: Montserrat;
    margin: 20px; 
    .ant-pattern{
    width: 60px;
    box-sizing: border-box;
    height: 32px;
    padding: 9px;
    border-radius: 5px;
    border: 1px solid #d9d9d9;
    }
    .headerBody{
        font-family: inherit;
        color: #354D62;
        width: 75%;
    }
    .radioSelected{
        background-color: #335D7C;
        color: #fff;
    }
    .process-date-label{
        margin-right: 4%;
        margin-left: 2%;
    }
    .item{
        padding-top: 10px;
    }
    h3{
        padding-top: 25px;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 12px;
        color: #8493AA;
    }
    .jusitify{
        margin-left: 9%;
    }
    .switchClass{
        font-weight: 500;
        font-size: 14px;
        line-height: 150%;
    }
    .SelectDate{
        margin: 20px 0px;
        font-size: 14px;
        line-height: 200%;
        font-weight: 500;
    }
    
    .ant-radio-group{
        font-family: inherit;
        font-weight: 500;
    }
    
    .footer{
        position: absolute;
        bottom: 0;
        right: 0;
        height: 10%;
        .ant-btn-primary {
            color: #fff;
            background-color: #335D7C;
            border-color:  #335D7C;
            border-radius: 20px;
            font-weight: bold;
            width: 116px;
            height: 36px;
        }
        .ant-btn-background-ghost {
            background: transparent !important;
            border-color: #fff;
            color: #335D7C;
            font-weight: bold;
            width: 116px;
            height: 36px;
        }  
    }

    .ant-styled{
        width: 83%;
        height: 32px;
        border-radius: 5px;
        border: 1px solid #d9d9d9;
        box-sizing: border-box;
        padding: 10px;
        color: rgba(0,0,0,0.65);
    }
    .extract-answers{
        margin-top: 20px;
        .ant-checkbox-checked .ant-checkbox-inner{
            background-color: #335D7C;
            border-color: #335D7C;
        }
    }
    .extract-answers-alert {
        display: block;
        margin-top: 10px;
        color: red;
        font-size: 10px;
    }
`


